<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Kontakty</h1>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Kontakty' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    contacts: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  // watch: {
  //   form: {
  //     deep: true,
  //     handler: throttle(function() {
  //       this.$inertia.get(this.route('contacts'), pickBy(this.form), { preserveState: true })
  //     }, 150),
  //   },
  // },
  // methods: {
  //   reset() {
  //     this.form = mapValues(this.form, () => null)
  //   },
  // },
}
</script>
